export const YOUTUBEMATCH_URL =
    // eslint-disable-next-line no-useless-escape
    /^(?:(?:https|http):\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be).(?:\/|v\/|u\/|embed\/|shorts\/|watch\?v=)(?<id>[\w\-]{11})(?=\?|&|$)/;
export const VIMEOMATCH_URL =
    /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/; // eslint-disable-line no-useless-escape

export const isYoutube = (url) => YOUTUBEMATCH_URL.test(url);
export const isVimeo = (url) => VIMEOMATCH_URL.test(url);
export const getYoutubeSrc = (url) => {
    const id = url?.match(YOUTUBEMATCH_URL)?.groups?.id;
    return {
        srcID: id,
        srcType: 'youtube',
        url,
    };
};
export const getVimeoSrc = (url) => {
    const id = url?.match(VIMEOMATCH_URL)[3];
    return {
        srcID: id,
        srcType: 'vimeo',
        url,
    };
};

export const YOUTUBE_PREFIX = 'https://www.youtube.com/embed/';
export const VIMEO_PREFIX = 'https://player.vimeo.com/video/';

export const getSrc = ({ src }) => {
    if (isYoutube(src)) {
        const { srcID } = getYoutubeSrc(src);
        return `${YOUTUBE_PREFIX}${srcID}`;
    }
    if (isVimeo(src)) {
        const { srcID } = getVimeoSrc(src);
        return `${VIMEO_PREFIX}${srcID}`;
    }
    return undefined;
};
